import React ,{useState,useEffect} from 'react'
import { CommonModal } from '../../CommonModal'
import LoadingSpinner from '../LoadingSpinner'
import { handleApi } from '../../../utils/authentication'

const UTMGenerateModal = ({
     external_campaign_id,
    generateUtmModal,
    setGenerateUtmModal,
    selectedAd,
    campaign_name,
    platform_id,
    handleListAds
   

   

}) => {


  const [utmParams, setUtmParams] = useState({
    website_url: '',
    campaign_id: external_campaign_id || '', 
    utm_source: '',
    utm_medium: '',
    utm_campaign: '', // Leave empty initially
    utm_term: '',
    utm_content: '',
    post_id:''
  });
  const [generatedUrl, setGeneratedUrl] = useState('');
  const [copied, setCopied] = useState(false); // Track if URL is copied
  const [saveUtmStatus, setSaveUtmStatus] = useState(''); // Track save status
  const [formLoading, setFormLoading] = useState(false)

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUtmParams((prev) => {
      const updatedParams = { ...prev, [name]: value };
      generateUtmUrl(updatedParams); // Automatically generate URL on input change
      return updatedParams;
    });
  };

    // Function to generate the UTM URL
    const generateUtmUrl = (params) => {
        const { website_url, campaign_id, utm_source, utm_medium, utm_campaign, utm_term, utm_content } = params;
    
        // Basic validation: Ensure all required fields are filled
        if (!website_url || !campaign_id || !utm_source || !utm_medium || !utm_campaign) {
          setGeneratedUrl(''); // Clear the URL if required fields are missing
          return;
        }
    
        // Construct the UTM URL
        let url = `${website_url}?utm_source=${utm_source}&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}&utm_id=${campaign_id}`;
    
        if (utm_term) url += `&utm_term=${utm_term}`;
        if (utm_content) url += `&utm_content=${utm_content}`;
    
        setGeneratedUrl(url); // Update the generated URL
      };



        // Function to save UTM to the backend
  const saveUtm = async () => {
    try {
      setSaveUtmStatus('Saving...');
      let formdata = new FormData();

      formdata.append('website_url', utmParams.website_url);
      formdata.append('campaign_id', utmParams.campaign_id);
      formdata.append('campaign_source', utmParams.utm_source);
      formdata.append('campaign_medium', utmParams.utm_medium);
      formdata.append('campaign_name', utmParams.utm_campaign);
      formdata.append('campaign_term', utmParams.utm_term);
      formdata.append('campaign_content', utmParams.utm_content);
      formdata.append('post_id', utmParams.post_id);
      formdata.append('utm_url', generatedUrl);
      formdata.append('ads_id', selectedAd?.id); 
      formdata.append('platform_id',platform_id);

      // Make the API request to save UTM
      let endpoint = ""
      if (selectedAd?.utm_flag) {
        endpoint = "edit_utm"
      } else {
        endpoint = "create_utm"
      }
      let response = await handleApi(endpoint, 'POST', {}, formdata);
      if (response?.success) {
        setSaveUtmStatus('Saved!');
        handleListAds()
      
      
      } else {
        setSaveUtmStatus('Failed to save');
      }
    } catch (e) {
      console.log(e);
      setSaveUtmStatus('Error occurred');
    }finally{
        setTimeout(() => setSaveUtmStatus(''), 4000); // Reset copied state after 2 seconds
    }
  };

  // Reset state when modal is closed
  const handleModalClose = () => {
    setGenerateUtmModal(false);

  };
  // Function to handle copying the URL to the clipboard
  const handleCopyUrl = () => {
    navigator.clipboard.writeText(generatedUrl);
    setCopied(true); // Set copied state to true
    setTimeout(() => setCopied(false), 2000); // Reset copied state after 2 seconds
  };
  useEffect(() => {

    const getAdsDetails = async () => {
      try {
        setUtmParams({
          website_url: '',
          campaign_id: external_campaign_id || '', // Prefill from params
          utm_source: '',
          utm_medium: '',
          utm_campaign: campaign_name || '', // Prefill from externalCampaignDetails
          utm_term: '',
          utm_content: '',
          post_id:''
        });
        if (selectedAd?.id && selectedAd?.utm_flag) {
          setFormLoading(true)
          let formData = new FormData()
          formData.append('ads_id', selectedAd.id)
          formData.append('campaign_id',external_campaign_id);
          formData.append('platform_id',platform_id);
          let result = await handleApi('get_utm', 'POST', {}, formData)
          if (result?.success) {
            setUtmParams({
              website_url: result?.data?.website_url,
              campaign_id: external_campaign_id || '', // Prefill from params
              utm_source: result?.data?.campaign_source,
              utm_medium: result?.data?.campaign_medium,
              utm_campaign: campaign_name || '',
              utm_term: result?.data?.campaign_term,
              utm_content: result?.data?.campaign_content,
              post_id: result?.data?.post_id || '',
            });
            setGeneratedUrl(result?.data?.utm_url)


          }
        }
        setFormLoading(false)

      } catch (e) {
        console.log(e)
        setFormLoading(false)
      }



    }

    getAdsDetails()

  }, [selectedAd])


  return (
    <CommonModal
    size={'lg'}
    title={
      <>
        <div className="d-flex flex-column gap-1">
          <span className="fs-6 fw-bold">Generate UTM for {selectedAd?.name}</span>
        </div>
      </>
    }
    body={
      <div>
        {formLoading && <LoadingSpinner />}
        <div className="mb-3">
          <label className="form-label">Full Website URL <span className="text-danger">*</span></label>
          <input
            type="text"
            className="form-control"
            name="website_url"
            placeholder="e.g., https://www.example.com"
            value={utmParams.website_url}
            onChange={handleInputChange}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Ad Campaign ID <span className="text-danger">*</span></label>
          <input
            type="text"
            className="form-control"
            name="campaign_id"
            placeholder="e.g., 123"
            value={utmParams.campaign_id}
            onChange={handleInputChange}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Campaign Source <span className="text-danger">*</span></label>
          <input
            type="text"
            className="form-control"
            name="utm_source"
            placeholder="e.g., google"
            value={utmParams.utm_source}
            onChange={handleInputChange}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Marketing Medium <span className="text-danger">*</span></label>
          <input
            type="text"
            className="form-control"
            name="utm_medium"
            placeholder="e.g., cpc, banner, email"
            value={utmParams.utm_medium}
            onChange={handleInputChange}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Campaign Name <span className="text-danger">*</span></label>
          <input
            type="text"
            className="form-control"
            name="utm_campaign"
            placeholder="e.g., spring_sale"
            value={utmParams.utm_campaign}
            onChange={handleInputChange}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Campaign Term (optional)</label>
          <input
            type="text"
            className="form-control"
            name="utm_term"
            placeholder="e.g., shoes, running, winter"
            value={utmParams.utm_term}
            onChange={handleInputChange}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Campaign Content (optional)</label>
          <input
            type="text"
            className="form-control"
            name="utm_content"
            placeholder="e.g., banner_ad, text_ad"
            value={utmParams.utm_content}
            onChange={handleInputChange}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Post Id (optional)</label>
          <input
            type="text"
            className="form-control"
            name="post_id"
            placeholder="e.g., banner_ad, text_ad"
            value={utmParams.post_id}
            onChange={handleInputChange}
          />
        </div>
        {generatedUrl ? (
          <div className="mt-3">
            <label className="mb-2">Generated URL</label>
            <textarea
              type="text"
              className="form-control utm_url"
              value={generatedUrl}
              rows={3}

              readOnly
              onClick={(e) => e.target.select()}
            />
            <div className='mt-2'>
              <button className="btn btn-secondary mt-2" onClick={handleCopyUrl}>
                {copied ? 'Copied!' : 'Copy URL'}
              </button>
              <button
                className="btn btn-primary mt-2 ms-2"
                onClick={saveUtm}
              >
                {saveUtmStatus || 'Save UTM'}
              </button>

            </div>

          </div>
        ) : (
          <div className="mt-3 text-muted">
            <p>Fill all the required fields to generate the URL.</p>
          </div>
        )}
      </div>
    }
    show={generateUtmModal}
    setShow={handleModalClose} // Reset state on modal close
  />
  )
}

export default UTMGenerateModal